export default __webpack_public_path__ + "static/media/Chat-Numbers-System-13.58f51c44.svg";